module.exports = __webpack_public_path__ + "2acb60f2/img/document.e2130c6b.svg";